// extracted by mini-css-extract-plugin
export default {"descripContainer":"descripcion_descripContainer__mvvB0","infoContainer":"descripcion_infoContainer__zb8tU","imgContainer":"descripcion_imgContainer__w1htE"};